/*
 *
 * AmbassadorsSummary actions
 *
 */

import {
  GET_AMBASSADORS_SUMMARY_WATCHER,
  GET_AMBASSADORS_SUMMARY_SUCCESS,
  GET_AMBASSADORS_SUMMARY_FAILED,
  UPLOAD_TEMPLATE_AMBASSADORS_WATCHER,
  UPLOAD_TEMPLATE_AMBASSADORS_SUCCESS,
  UPLOAD_TEMPLATE_AMBASSADORS_FAILED,
  SAVE_EXCEL_AMBASSADORS_WATCHER,
  SAVE_EXCEL_AMBASSADORS_SUCCESS,
  SAVE_EXCEL_AMBASSADORS_FAILED,
  SAVE_EXCEL_AMBASSADORS_PROGRESS,
  GET_LANGUAGE_WATCHER,
  GET_LANGUAGE_SUCCESS,
  GET_LANGUAGE_FAILED,
} from "./constants"
// GET LANGAUGE
export function getLanguageWatcher(payload) {
  return {
    type: GET_LANGUAGE_WATCHER,
    payload,
  }
}

export function getLanguageSuccess(payload) {
  return {
    type: GET_LANGUAGE_SUCCESS,
    payload,
  }
}

export function getLanguageFailed(payload) {
  return {
    type: GET_LANGUAGE_FAILED,
    payload,
  }
}
// SAVE EXCEL COLLABORATORS
export function saveExcelAmbassadorsWatcher(payload) {
  return {
    type: SAVE_EXCEL_AMBASSADORS_WATCHER,
    payload,
  }
}

export function saveExcelAmbassadorsSuccess(payload) {
  return {
    type: SAVE_EXCEL_AMBASSADORS_SUCCESS,
    payload,
  }
}

export function saveExcelAmbassadorsFailed() {
  return { type: SAVE_EXCEL_AMBASSADORS_FAILED }
}

export function saveExcelAmbassadorsProgress(payload) {
  return {
    type: SAVE_EXCEL_AMBASSADORS_PROGRESS,
    payload,
  }
}

// GET SUMMARY COLLABORATORS
export function getAmbassadorsSummaryWatcher() {
  return { type: GET_AMBASSADORS_SUMMARY_WATCHER }
}

export function getAmbassadorsSummarySuccess(payload) {
  return {
    type: GET_AMBASSADORS_SUMMARY_SUCCESS,
    payload,
  }
}

export function getAmbassadorsSummaryFailed() {
  return { type: GET_AMBASSADORS_SUMMARY_FAILED }
}

// UPLOAD EXCEL
export function uploadTemplateAmbassadorsWatcher(payload) {
  return {
    type: UPLOAD_TEMPLATE_AMBASSADORS_WATCHER,
    payload,
  }
}

export function uploadTemplateAmbassadorsSuccess(payload) {
  return {
    type: UPLOAD_TEMPLATE_AMBASSADORS_SUCCESS,
    payload,
  }
}

export function uploadTemplateAmbassadorsFailed(payload) {
  return {
    type: UPLOAD_TEMPLATE_AMBASSADORS_FAILED,
    payload,
  }
}
